var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"global_tip"},[_c('div',{staticClass:"tip_list"},_vm._l((_vm.globalTip),function(item,index){return _c('div',{key:index,class:['tip_item', 'animated', _vm.time >= item.expire ? 'animate__backOutRight' : 'animate__backInRight', item.type]},[_vm._v(_vm._s(item.message))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }